import { Component, Inject, OnInit } from '@angular/core';
//import {Component, Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {CommonModule, NgIf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
  selector: 'app-dialog-popup',
  templateUrl: './dialog-popup.component.html',
  styleUrls: ['./dialog-popup.component.scss'],
 standalone:true,
 imports:[CommonModule]
})
export class DialogPopupComponent implements OnInit {
  display: string;
  choice: boolean=false;
  resultVal: string;
  //public dialogRef=MatDialogRef<DialogPopupComponent>
  constructor(
    
    public dialogRef: MatDialogRef<DialogPopupComponent>,
    public dialogReffstart: MatDialogRef<DialogPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogReffstart.disableClose=true;
    const time=data.timer
    const timer=time+2;
    this.timer(timer)
    this.choice=data.choice;
    console.log(this.choice,'choice')
   }

  ngOnInit(){

  }
  onclickyes(e){
    this.resultVal=e;
    this.dialogRef.close(e);
  }
  onclickno(e){
    this.dialogRef.close(e);
  }

  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if(this.resultVal=='yes'){
        clearInterval(timer);
      }
      else if (seconds == 0) {
        console.log('lapsedaddcallibration')
        
        this.dialogRef.close("timelapsed");
        clearInterval(timer);
      }
    }, 1000);
  }

  onCancelClick(): void {
    console.log('stop calli')
    this.dialogReffstart.close("stop Callibration");
  }

}


